import { Box } from '@deckee/deck-hand';
import React, { FC } from 'react';
import { useTheme } from 'styled-components';
import {
  batteryEmpty,
  batteryCharged1,
  batteryCharged3,
  batteryCharged5,
  batteryCharged7,
  batteryFull,
  ReactSvg,
} from '../../../shared/vector-images';

interface BatteryLevelIndicatorProps {
  batteryLevel: number | null;
  size?: number;
  showTextLabel?: boolean;
  color?: string;
  marginLeft?: number;
  marginRight?: number;
}

const BatteryLevelIndicator: FC<BatteryLevelIndicatorProps> = ({
  batteryLevel,
  showTextLabel,
  size,
  color,
  marginLeft,
  marginRight,
}) => {
  const theme = useTheme();

  const renderedColor = color || theme.colors.darkergrey;

  let batteryLevelIconToDisplay;
  switch (true) {
    case batteryLevel !== null && batteryLevel < 10:
      batteryLevelIconToDisplay = batteryEmpty();
      break;
    case batteryLevel !== null && batteryLevel < 30:
      batteryLevelIconToDisplay = batteryCharged1();
      break;
    case batteryLevel !== null && batteryLevel < 50:
      batteryLevelIconToDisplay = batteryCharged3();
      break;
    case batteryLevel !== null && batteryLevel < 70:
      batteryLevelIconToDisplay = batteryCharged5();
      break;
    case batteryLevel !== null && batteryLevel < 90:
      batteryLevelIconToDisplay = batteryCharged7();
      break;
    default:
      batteryLevelIconToDisplay = batteryFull();
      break;
  }

  return batteryLevel !== null && batteryLevel >= 0 ? (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="flex-start"
      ml={marginLeft}
      mr={marginRight}
    >
      {!showTextLabel && (
        <Box mr={1} fontSize={1} color={renderedColor}>
          {`${Math.floor(batteryLevel)}%`}
        </Box>
      )}
      <ReactSvg
        toDisplay={batteryLevelIconToDisplay}
        options={{
          fillColor: renderedColor,
        }}
        width={size}
        height={size}
      />
      {showTextLabel && (
        <Box ml={1} fontSize={1} color={renderedColor}>
          {`${Math.floor(batteryLevel)}% Battery charge`}
        </Box>
      )}
    </Box>
  ) : null;
};

BatteryLevelIndicator.defaultProps = {
  size: 22,
  showTextLabel: true,
  color: undefined,
  marginLeft: undefined,
  marginRight: undefined,
};

export default BatteryLevelIndicator;
